import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BreakpointService {
  private windowWidth = signal(
    typeof window !== 'undefined' ? window.innerWidth : 1024
  );

  // Breakpoints basados en Tailwind CSS
  readonly breakpoints = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
  };

  // Computed signals para cada breakpoint
  isMobile = computed(() => this.windowWidth() < this.breakpoints.md);
  isTablet = computed(
    () =>
      this.windowWidth() >= this.breakpoints.md &&
      this.windowWidth() < this.breakpoints.lg
  );
  isDesktop = computed(() => this.windowWidth() >= this.breakpoints.lg);

  constructor() {
    if (typeof window !== 'undefined') {
      // Listener para cambios de tamaño de ventana
      window.addEventListener('resize', () => {
        this.windowWidth.set(window.innerWidth);
      });
    }
  }

  getCurrentBreakpoint(): 'mobile' | 'tablet' | 'desktop' {
    const width = this.windowWidth();

    if (width < this.breakpoints.md) return 'mobile';
    if (width < this.breakpoints.lg) return 'tablet';
    return 'desktop';
  }
}
